var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBolso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 64H86.948C93.724 64 100.224 61.308 105.016 56.516C109.808 51.724 112.5 45.224 112.5 38.448V38.444C112.5 36.734 111.822 35.096 110.612 33.888C109.404 32.678 107.766 32 106.056 32C88.578 32 40.422 32 22.944 32C21.234 32 19.596 32.678 18.388 33.888C17.178 35.096 16.5 36.734 16.5 38.444V38.448C16.5 45.224 19.192 51.724 23.984 56.516C28.776 61.308 35.276 64 42.052 64C50.834 64 58.5 64 58.5 64",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 50V93.83C18.5 95.998 19.36 98.076 20.892 99.608C22.424 101.14 24.502 102 26.67 102C34.996 102 48.626 102 62.5 102",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.33 102C104.498 102 106.576 101.14 108.108 99.608C109.64 98.076 110.5 95.998 110.5 93.83C110.5 79.19 110.5 50 110.5 50",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 32V23.958C88.5 21.772 86.728 20 84.542 20C75.514 20 53.486 20 44.458 20C42.272 20 40.5 21.772 40.5 23.958C40.5 27.454 40.5 32 40.5 32",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5 62C70.5 60.408 69.868 58.882 68.742 57.758C67.618 56.632 66.092 56 64.5 56C62.908 56 61.382 56.632 60.258 57.758C59.132 58.882 58.5 60.408 58.5 62C58.5 63.932 58.5 66.072 58.5 68.004C58.5 69.594 59.132 71.12 60.256 72.244C61.38 73.368 62.906 74 64.496 74H64.5C66.092 74 67.618 73.368 68.742 72.242C69.868 71.118 70.5 69.592 70.5 68C70.5 66.07 70.5 63.93 70.5 62Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.5 83C102.5 79.686 99.814 77 96.5 77C90.782 77 82.218 77 76.5 77C73.186 77 70.5 79.686 70.5 83C70.5 87.04 70.5 92.456 70.5 97.102C70.5 103.008 73.964 108.364 79.35 110.784C83.048 112.448 86.5 114 86.5 114C86.5 114 89.952 112.448 93.65 110.784C99.036 108.364 102.5 103.008 102.5 97.102V83Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94.496L85 98.496L93 91.496",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 94H31.308C30.032 94 28.81 93.494 27.908 92.592C27.006 91.69 26.5 90.468 26.5 89.192V84",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolso);
export default __webpack_public_path__ + "static/media/bolso.758b2fe59fe59b2304d957bbf60cc61c.svg";
export { ForwardRef as ReactComponent };